import { useEffect, useState } from 'react';
import './PartWorkspace.scss';
import api from '../../../../utils/api';
import { Button, Icon, Label, Tab, Accordion, AccordionTitle, AccordionContent } from 'semantic-ui-react';
import getTwoSymbols from '../../../../utils/getTwoSymbols';
import Project from '../../../../structures/project';
import ProjectPart from '../../../../structures/projectPart';
import { useParams } from 'react-router';
import { useNavigate } from "react-router";
import CreateFragmentModal from './components/CreateFragmentModal/CreateFragmentModal';
import ImagesCollage from '../ImagesCollage/ImagesCollage';
import Fragment, { FragmentType } from '../../../../structures/fragment';
import DialogEditor from '../DialogEditor/DialogEditor';
import PercentProgress from '../../../../shared/PercentProgress/PercentProgress';
import AutoSaveTextArea from '../../../../shared/AutoSaveTextArea/AutoSaveTextArea';
import InventFinishContentButton from './components/InventFinishContentButton/InventFinishContentButton';
import FinalContentForPart from './components/FinalContentForPart/FinalContentForPart';

const getTitleForFragment = (project:Project, fragment: Fragment) => {
    if(fragment.type == FragmentType.Dialog){
        return <><b>{fragment.type}</b>: {fragment.description}</>;
    }
    if(fragment.type == FragmentType.HeroDescription){
        return <><b>{fragment.type}</b>: {fragment.members.map(x => {
            let member = project.members.find(m=>m.id ==x)!;
            return `${member.name} (${member.role})`;
        })[0]} - {fragment.description}</>;
    }
    return `${fragment.type}`
}
const getFragmentContent = (project:Project, part: ProjectPart, fragment: Fragment) => {
    if(fragment.type === FragmentType.Dialog){
        return <DialogEditor 
            project={project}
            part={part}
            fragment={fragment}
        />;
    }
    return ``
}

interface PartWorkspaceProps{
    project: Project
    parts: ProjectPart[]
}
function PartWorkspace({parts, project}: PartWorkspaceProps) {
    const [isOpenCreateFragmentModal, setIsOpenCreateFragmentModal] = useState(false) 
    const [fragments, setFragments] = useState<Fragment[]>([]) 
    const [activeFragments, setActiveFragments] = useState<string[]>([]) 
    const [activePartTypes, setActivePartTypes] = useState<string[]>([]) 

    const { partId } = useParams() as { partId: string };
    let part = parts.map((x, i)=> {return {part: x, index: i}}).find(x=>x.part.id == partId);
    const navigate = useNavigate()
    const loadFragments = () => {api.getFragments(part?.part.id!).then(fragments => setFragments(fragments))}
    useEffect(loadFragments, []);
    useEffect(loadFragments, [partId]);
    if(project == null || part == null) return <></>
    return <div className='part-workspace'>
        <div className='header'>
            <div><h1><span className='part-index'>{getTwoSymbols(part?.index!)}</span> {part?.part.name} <PercentProgress percent={(fragments.length/50) * 100}/></h1></div>
            <div><ImagesCollage items={project.members.filter(x=> fragments.map(f=>f.members).flat().includes(x.id))}/></div>
            <div><ImagesCollage items={project.places.filter(x=> fragments.map(f=>f.places).flat().includes(x.id))}/></div>
        </div>

<Tab
    menu={{ secondary: true, pointing: true }} 
    panes={[
        { menuItem: 'Структура', render: () => <div>
            <Accordion styled fluid>
                {['Завязка', 'Развитие', 'Развязка'].map(partType=><>
                    <AccordionTitle
                        active={activePartTypes.includes(partType)}
                        index={partType}
                        onClick={()=>{setActivePartTypes(old => {
                            let a = old.map(x=>x);
                            if(a.includes(partType)){
                                a = a.filter(x=>x != partType);
                            }else{
                                a.push(partType)
                            }
                            return a
                        })}}
                        >
                        <Icon name='dropdown' />
                        <Label color='blue' content={partType} />
                    </AccordionTitle>
                    <AccordionContent active={activePartTypes.includes(partType)}>
                        <Accordion>
                            {fragments.map(fragment => {
                                return <>
                                    <AccordionTitle
                                        active={activeFragments.includes(fragment.id)}
                                        index={fragment.id}
                                        onClick={()=>{setActiveFragments(old => {
                                            let a = old.map(x=>x);
                                            if(a.includes(fragment.id)){
                                                a = a.filter(x=>x != fragment.id);
                                            }else{
                                                a.push(fragment.id)
                                            }
                                            return a
                                        })}}
                                        >
                                        <Icon name='dropdown' />
                                        {getTitleForFragment(project, fragment)}
                                    </AccordionTitle>
                                    <AccordionContent active={activeFragments.includes(fragment.id)}>
                                        <Tab
                                            menu={{ secondary: true, pointing: true }} 
                                            panes={[
                                                { menuItem: 'Структура', render: () => <div>
                                                    {getFragmentContent(project, part?.part!, fragment)}
                                                </div> },
                                                { menuItem: 'Литературный вид', render: () => <div>
                                                    <AutoSaveTextArea value={fragment.finishContent} onChange={(finishContent, setIsLoading) => {
                                                        setIsLoading(true);
                                                        api
                                                        .updateFragmentFinishContent(project.id, part?.part!.id!, fragment.id, finishContent)
                                                        .then(()=>{
                                                            setFragments(old => old.map(f=>f.id == fragment.id ? {...f, finishContent} : f))
                                                            setIsLoading(false)
                                                        });
                                                    }}/>
                                                    {fragment.finishContent == '' ? <InventFinishContentButton projectId={project.id} partId={part?.part!.id!} fragmentId={fragment.id} onInvent={content => {
                                                        api.updateFragmentFinishContent(project.id, part?.part!.id!, fragment.id, content).then(loadFragments)
                                                        }} /> : ''}
                                                </div> },
                                            ]}/>
                                    </AccordionContent>
                                </>;
                            })}
                        </Accordion>
                        <div className='add-fragment-btns'>
                            <Button icon primary fluid size='tiny' onClick={()=>{setIsOpenCreateFragmentModal(true)}}><Icon name='plus'/> Добавить фрагмент</Button>
                        </div>
                    </AccordionContent>
                </>)}
            </Accordion>
        </div> },
        { menuItem: 'Литературный вид', render: () => <div>
            <FinalContentForPart projectId={project.id} partId={part?.part!.id!} />
        </div> },
    ]}/>
        <CreateFragmentModal 
                open={isOpenCreateFragmentModal} 
                setOpen={setIsOpenCreateFragmentModal} 
                project={project}
                partId={partId}
                onSave={fragment => {
                    setIsOpenCreateFragmentModal(false); 
                    setFragments([...fragments, fragment])
                }}/>
    </div>;
};

export default PartWorkspace;